import { render, staticRenderFns } from "./PrincipaisOrigensImpo.vue?vue&type=template&id=3252b486"
import script from "./PrincipaisOrigensImpo.vue?vue&type=script&lang=js"
export * from "./PrincipaisOrigensImpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports